"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_helmet_1 = require("react-helmet");
var Layout_1 = require("../../components/Layout");
var styles_1 = require("./styles");
var IconSkills_1 = __importDefault(require("../../components/Layout/IconSkills"));
var constant_1 = require("../../constant");
var Skills = function () {
    var _a = react_1.useState(false), icon1 = _a[0], setIcon1 = _a[1];
    var _b = react_1.useState(false), icon2 = _b[0], setIcon2 = _b[1];
    var _c = react_1.useState(false), icon3 = _c[0], setIcon3 = _c[1];
    var _d = react_1.useState(false), icon4 = _d[0], setIcon4 = _d[1];
    var _e = react_1.useState(false), icon5 = _e[0], setIcon5 = _e[1];
    var _f = react_1.useState(false), icon6 = _f[0], setIcon6 = _f[1];
    var _g = react_1.useState(false), showPen = _g[0], SetShowPen = _g[1];
    react_1.useEffect(function () {
        setIcon1(true);
        var timeout1 = setTimeout(function () { return setIcon2(true); }, 500);
        var timeout2 = setTimeout(function () { return setIcon3(true); }, 700);
        var timeout3 = setTimeout(function () { return setIcon4(true); }, 900);
        var timeout4 = setTimeout(function () { return setIcon5(true); }, 1100);
        var timeout5 = setTimeout(function () { return setIcon6(true); }, 1300);
        var timeout6 = setTimeout(function () { return SetShowPen(true); }, 1500);
        return function () {
            clearTimeout(timeout1);
            clearTimeout(timeout2);
            clearTimeout(timeout3);
            clearTimeout(timeout4);
            clearTimeout(timeout5);
            clearTimeout(timeout6);
        };
    }, []);
    return (react_1.default.createElement(styles_1.SkillsContainer, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null,
                "Comp\u00E9tences - ",
                constant_1.SITE_TITLE),
            react_1.default.createElement("meta", { name: "description", content: "D\u00E9couvrez les diff\u00E9rentes comp\u00E9tences de Gloria Luzio dans le d\u00E9veloppement web, mobile, et plus particuli\u00E8rement React" }),
            react_1.default.createElement("meta", { property: "og:title", content: "Comp\u00E9tences | Gloria Luzio - d\u00E9veloppeuse Javascript React - Paris" }),
            react_1.default.createElement("meta", { property: "og:description", content: "D\u00E9couvrez les diff\u00E9rentes comp\u00E9tences de Gloria Luzio dans le d\u00E9veloppement web, mobile, et plus particuli\u00E8rement React" }),
            react_1.default.createElement("meta", { property: "og:url", content: "https://www.glorialuzio.fr/competences" })),
        react_1.default.createElement(styles_1.Pen, { show: showPen }),
        react_1.default.createElement(Layout_1.PostItContainer, null,
            react_1.default.createElement(IconSkills_1.default, { backgroundColor: "yellow", show: icon1, icon: "javascript", skillTitle: "Javascript", rotate: -10 }),
            react_1.default.createElement(IconSkills_1.default, { backgroundColor: "#D2F7A6", show: icon2, icon: "html", skillTitle: "HTML/CSS", rotate: 1 }),
            react_1.default.createElement(IconSkills_1.default, { backgroundColor: "yellow", show: icon3, icon: "gatsby", skillTitle: "Gatsby", rotate: 6 }),
            react_1.default.createElement(IconSkills_1.default, { backgroundColor: "#EF8533", show: icon4, icon: "typescript", skillTitle: "TypeScript", rotate: 3 }),
            react_1.default.createElement(IconSkills_1.default, { backgroundColor: "#43A6DD", show: icon5, icon: "nodejs", skillTitle: "Node JS", rotate: -5 }),
            react_1.default.createElement(IconSkills_1.default, { backgroundColor: "pink", show: icon6, icon: "react", skillTitle: "React / React Native", rotate: 10 }))));
};
exports.default = Skills;
